import { useQuery } from "@tanstack/react-query";
import {
  getAssetDetailsByTagRequest,
  getAssetRequest,
} from "../requests/asset";

export function useAssetDetailsByTag({ tagId, config }) {
  return useQuery({
    queryKey: [`/v1/asset/tag/${tagId}/details`],
    queryFn: async () => {
      const res = await getAssetDetailsByTagRequest({ tagId, config });
      return res.data?.data;
    },
    enabled: Boolean(tagId),
  });
}

export function useGetAsset(config) {
  return useQuery({
    queryKey: [`/v1/asset`, config],
    queryFn: async () => {
      const res = await getAssetRequest(config);
      return res.data;
    },
    enabled: false,
  });
}
